import React, { useState, useEffect } from 'react';
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import './responsive.css';
import Dashboard from './pages/Dashboard.jsx';
import Workers from './pages/Workers.jsx';
import Attendance from './pages/Attendance.jsx';
import Payroll from './pages/Payroll.jsx';
import Leave from './pages/Leave.jsx';
import LeaveTypeMaster from './pages/LeaveTypeMaster.jsx';
import HolidayMaster from './pages/HolidayMaster.jsx';
import ShiftMaster from './pages/ShiftMaster.jsx';
import Reports from './pages/Reports.jsx';
import UserManagement from './pages/UserManagement.jsx';
import Login from './components/Login.jsx';
import { HRMSProvider } from './context/HRMSContext.jsx';

function App() {
  const [currentPage, setCurrentPage] = useState('dashboard');
  const [pageHistory, setPageHistory] = useState(['dashboard']);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('token');
    const userData = localStorage.getItem('user');
    
    if (token && userData) {
      setIsAuthenticated(true);
      setUser(JSON.parse(userData));
    }
    setLoading(false);

    // Handle browser back button
    const handlePopState = () => {
      if (pageHistory.length > 1) {
        const newHistory = [...pageHistory];
        newHistory.pop(); // Remove current page
        const previousPage = newHistory[newHistory.length - 1];
        setCurrentPage(previousPage);
        setPageHistory(newHistory);
      }
    };

    window.addEventListener('popstate', handlePopState);
    return () => window.removeEventListener('popstate', handlePopState);
  }, [pageHistory]);

  const handleLogin = (userData, token) => {
    setIsAuthenticated(true);
    setUser(userData);
  };

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    setIsAuthenticated(false);
    setUser(null);
    setCurrentPage('dashboard');
    setPageHistory(['dashboard']);
  };

  const navigateToPage = (page) => {
    if (page !== currentPage) {
      setCurrentPage(page);
      setPageHistory(prev => [...prev, page]);
      window.history.pushState({ page }, '', `#${page}`);
    }
  };

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center vh-100">
        <div className="spinner-border" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Login onLogin={handleLogin} />;
  }

  const renderPage = () => {
    try {
      switch(currentPage) {
        case 'workers': return <Workers />;
        case 'attendance': return <Attendance />;
        case 'payroll': return <Payroll />;
        case 'leave': return <Leave />;
        case 'leave-types': return <LeaveTypeMaster />;
        case 'holidays': return <HolidayMaster />;
        case 'shifts': return <ShiftMaster />;
        case 'reports': return <Reports />;
        case 'users': return <UserManagement />;
        default: return <Dashboard />;
      }
    } catch (error) {
      return <div className="alert alert-danger">Error loading page: {error.message}</div>;
    }
  };

  return (
    <HRMSProvider>
      <div className="hrms-app">
        <nav className="navbar navbar-expand-lg navbar-dark bg-primary">
          <div className="container-fluid">
            <span className="navbar-brand">HRMS System</span>
            <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav">
              <span className="navbar-toggler-icon"></span>
            </button>
            <div className="collapse navbar-collapse" id="navbarNav">
              <div className="navbar-nav me-auto">
                <button className={`nav-link btn btn-link text-white ${currentPage === 'dashboard' ? 'active' : ''}`} onClick={() => navigateToPage('dashboard')}>Dashboard</button>
                <button className={`nav-link btn btn-link text-white ${currentPage === 'workers' ? 'active' : ''}`} onClick={() => navigateToPage('workers')}>Workers</button>
                <button className={`nav-link btn btn-link text-white ${currentPage === 'attendance' ? 'active' : ''}`} onClick={() => navigateToPage('attendance')}>Attendance</button>
                <button className={`nav-link btn btn-link text-white ${currentPage === 'payroll' ? 'active' : ''}`} onClick={() => navigateToPage('payroll')}>Payroll</button>
                <button className={`nav-link btn btn-link text-white ${currentPage === 'leave' ? 'active' : ''}`} onClick={() => navigateToPage('leave')}>Leave</button>
                <button className={`nav-link btn btn-link text-white ${currentPage === 'leave-types' ? 'active' : ''}`} onClick={() => navigateToPage('leave-types')}>Leave Types</button>
                <button className={`nav-link btn btn-link text-white ${currentPage === 'holidays' ? 'active' : ''}`} onClick={() => navigateToPage('holidays')}>Holidays</button>
                <button className={`nav-link btn btn-link text-white ${currentPage === 'shifts' ? 'active' : ''}`} onClick={() => navigateToPage('shifts')}>Shifts</button>
                <button className={`nav-link btn btn-link text-white ${currentPage === 'reports' ? 'active' : ''}`} onClick={() => navigateToPage('reports')}>Reports</button>
                <button className={`nav-link btn btn-link text-white ${currentPage === 'users' ? 'active' : ''}`} onClick={() => navigateToPage('users')}>Users</button>
              </div>
              <div className="navbar-nav">
                <span className="navbar-text text-white me-3">Welcome, {user?.username}</span>
                <button className="btn btn-outline-light btn-sm" onClick={handleLogout}>Logout</button>
              </div>
            </div>
          </div>
        </nav>
        <main className="container-fluid mt-3 px-2 px-md-3">
          {renderPage()}
        </main>
      </div>
    </HRMSProvider>
  );
}

export default App;

